/**
 * In-memory handoff: Smoke Drive shipping-label prompt → Printing Toolkit Pack attach review.
 */

/** @type {{ blob: Blob, fileName: string, driveItemId?: string, source?: string, autoAttach?: boolean }|null} */
let pending = null;

/**
 * @param {{ blob: Blob, fileName?: string, driveItemId?: string, source?: string, autoAttach?: boolean }} payload
 */
export function setShippingLabelAttachHandoff(payload) {
  if (!(payload?.blob instanceof Blob) || !payload.blob.size) {
    throw new Error('A PDF file is required for shipping-label attach.');
  }
  pending = {
    blob: payload.blob,
    fileName: String(payload.fileName || 'shipping-labels.pdf').trim() || 'shipping-labels.pdf',
    driveItemId: payload.driveItemId ? String(payload.driveItemId) : undefined,
    source: payload.source ? String(payload.source) : 'smoke-drive',
    autoAttach: payload.autoAttach !== false,
  };
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('lsc:shipping-label-attach-handoff'));
  }
}

export function peekShippingLabelAttachHandoff() {
  return pending;
}

export function consumeShippingLabelAttachHandoff() {
  const next = pending;
  pending = null;
  return next;
}

export function clearShippingLabelAttachHandoff() {
  pending = null;
}
